import { render, staticRenderFns } from "./ModalSelectPreOrder.vue?vue&type=template&id=2c6b53de&scoped=true"
import script from "./ModalSelectPreOrder.vue?vue&type=script&lang=js"
export * from "./ModalSelectPreOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6b53de",
  null
  
)

export default component.exports